export const CONTACT_CONSTRAINTS = {
    contactName: { maxLength: 100, label: 'Contact Name' },
    preference: { label: 'Preferred Contact Method' },
    email: { maxLength: 256, label: 'Email Address' },
    phone: { maxLength: 256, label: 'Phone Number' },
    title: { maxLength: 100, label: 'Job Title' },
};
/** A new customer or vendor takes its first contacts inline; more are added on its page. */
export const MAX_NEW_CONTACTS = 20;
export const MAX_NEW_CONTACTS_MESSAGE = `Add at most ${MAX_NEW_CONTACTS} contacts here; add more from the Contacts card once it's created.`;
export const SINGLE_PRIMARY_CONTACT_MESSAGE = 'Only one contact can be the primary contact.';
//# sourceMappingURL=constraints.js.map